import { createContext, useContext } from "react";
import { type CuadraChatStrings, DEFAULT_STRINGS } from "../../types/strings";

export const StringsContext = createContext<CuadraChatStrings>(DEFAULT_STRINGS);
export const useStrings = () => useContext(StringsContext);
